import { BaseDataForm } from 'components/Layout/components/BaseDataAside/submenu';
import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

type ContextType = {
  activeUser: string;
  activeMenu: BaseDataForm | string;
  setActiveUser: Dispatch<SetStateAction<string>>;
  setActiveMenu: Dispatch<SetStateAction<string>>;
};

type Prop = {
  children: ReactNode;
};

const Context = createContext({} as ContextType);

const BaseDataAsideContext = ({ children }: Prop) => {
  const [activeUser, setActiveUser] = useState('');
  const [activeMenu, setActiveMenu] = useState('');

  return (
    <Context.Provider
      value={{
        activeUser,
        activeMenu,
        setActiveUser,
        setActiveMenu,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const useContextBaseDataAside = () => {
  return useContext(Context);
};

export default BaseDataAsideContext;
